const DEFAULT_ALLOWED_RELAY_HOSTS = [
  'claude.ai',
  'www.claude.ai',
  'claude.com',
  'www.claude.com',
  'chat.openai.com',
  'chatgpt.com',
  'www.chatgpt.com',
];

export function getMcpOauthRelayAllowedHosts(rawValue = process.env.REACT_APP_MCP_OAUTH_RELAY_ALLOWED_HOSTS) {
  const parsed = (rawValue || '')
    .split(',')
    .map((item) => item.trim().toLowerCase())
    .filter((item) => item.length > 0);

  return new Set(parsed.length > 0 ? parsed : DEFAULT_ALLOWED_RELAY_HOSTS);
}

export function buildMcpOauthRelayRedirect(
  currentHref,
  rawAllowedHosts = process.env.REACT_APP_MCP_OAUTH_RELAY_ALLOWED_HOSTS
) {
  if (typeof currentHref !== 'string' || currentHref.trim().length === 0) {
    return null;
  }

  let currentUrl;
  try {
    currentUrl = new URL(currentHref);
  } catch {
    return null;
  }

  const params = currentUrl.searchParams;
  const targetRaw = params.get('mcp_oauth_redirect');
  if (!targetRaw) {
    return null;
  }

  const hasOAuthResponseParams =
    params.has('code') ||
    params.has('error') ||
    params.has('state');
  if (!hasOAuthResponseParams) {
    return null;
  }

  let relayTarget;
  try {
    relayTarget = new URL(targetRaw);
  } catch {
    return null;
  }

  const relayHostname = relayTarget.hostname.toLowerCase();
  const isLoopback = relayHostname === '127.0.0.1' || relayHostname === '[::1]';
  const isSecureHostedCallback = relayTarget.protocol === 'https:';
  const isNativeLoopbackCallback = relayTarget.protocol === 'http:' && isLoopback;

  if (!isSecureHostedCallback && !isNativeLoopbackCallback) {
    return null;
  }

  const allowedHosts = getMcpOauthRelayAllowedHosts(rawAllowedHosts);
  if (!isLoopback && !allowedHosts.has(relayHostname)) {
    return null;
  }

  const forwardedParams = new URLSearchParams(currentUrl.search);
  forwardedParams.delete('mcp_oauth_redirect');

  for (const [key, value] of forwardedParams.entries()) {
    relayTarget.searchParams.set(key, value);
  }

  return relayTarget.toString();
}
